
import React, { createContext, useContext } from 'react';
import { ApiDashboardRepository } from '../repositories/ApiDashboardRepository';
import { DashboardUseCases } from '../../application/use-cases/DashboardUseCases';
import { useHttpClientCore } from '@/shared';
import { useReduxCustomDocumentTypeAdapter } from '@/features/section-2/infra/store/ReduxCustomDocumentTypeAdapter';

interface IDashboardDIContext {
  dashboardUseCases: DashboardUseCases;
  customDocumentTypeAdaptor: ReturnType<typeof useReduxCustomDocumentTypeAdapter>;
}

const DashboardDIContext = createContext<IDashboardDIContext | undefined>(undefined);

export const DashboardDIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const httpClient = useHttpClientCore();
  const repo = new ApiDashboardRepository(httpClient);
  const dashboardUseCases = new DashboardUseCases(repo);
  const customDocumentTypeAdaptor = useReduxCustomDocumentTypeAdapter();

  return (
    <DashboardDIContext.Provider value={{ dashboardUseCases, customDocumentTypeAdaptor }}>
      {children}
    </DashboardDIContext.Provider>
  );
};

export function useDashboardDIContext() {
  const ctx = useContext(DashboardDIContext);
  if (!ctx) throw new Error('useDashboardDIContext must be used within DashboardDIProvider');
  return ctx;
}
